import React, { useEffect, useState, Fragment } from "react";
import "./Channels.css";
import InnerNav from "components/InnerNav/InnerNav";
import type { MenuProps } from "antd";
import { t } from "i18next";
import { useSelector } from "react-redux";
import EmailNav from "../Email/EmailNav/EmailNav";
import PushNotification from "../PushNotification/PushNotification";
import SMS from "../SMS/SMS";
import WebPushNotification from "../WebPushNotification/WebPushNotification";
import CampaignAnalyticsNav from "../CampaignAnalytics/CampaignAnalyticsNav/CampaignAnalyticsNav";
import CampaignConfigurator from "../CampaignConfigurator/CampaignConfigurator";
import PushNotificationSetting from "../PushNotificationSetting/PushNotificationSetting";
import AllowList from "../AllowList/AllowList";
import GoogleMapKey from "../GoogleMapKey/GoogleMapKey";
import Budget from "../Budget/Budget";
import RateLimit from "../RateLimit/RateLimit";
import CampaignThreshold from "../CampaignSetting/CampaignThreshold/CampaignThreshold";
import StaggeredSend from "../StaggeredSend/StaggeredSend";
import Partner from "../Partner/Partner";
import ProviderSetting from "../ProviderSetting/ProviderSetting";
import AppInbox from "../AppInbox/AppInbox";
import Channel from "../Channel/Channel";
import { AppTabKey, CampaignSettingKey } from "utils/enums";
import EmailEditorSetting from "../Email/EmailEditorSetting/EmailEditorSetting";

interface ChannelsProps {
  currentAppKey?: any;
  fetchCurrentAppKeys?: any;
}

const Channels: React.FC<ChannelsProps> = ({
  currentAppKey,
  fetchCurrentAppKeys,
}) => {
  const [appTabFilter, setAppTabFilter] = useState<AppTabKey>(AppTabKey.Push);
  const [campaignSettingTab, setCampaignSettingTab] = useState<CampaignSettingKey>(CampaignSettingKey.CampaignAnalytics);
  const [selectedComponent, setSelectedComponent] =
    useState<JSX.Element | null>(null);

  const features = useSelector((state: any) => state.featuresSetting.data);
  const featuresSetting = features[0]?.features;



   const campaignSettingTabs: { label: string; key: CampaignSettingKey }[] = [
    { label: t("campaignAnalyticsLabel"), key: CampaignSettingKey.CampaignAnalytics },
    { label: t("campaignCongiguratorLabel"), key: CampaignSettingKey.CampaignConfigurator },
    { label: t("pushNotificationSettingLabel"), key: CampaignSettingKey.PushNotificationSettings },
    { label: t("editorSettingLabel"), key:CampaignSettingKey.BeeFreeEditor },

    ...(!featuresSetting?.allowList
      ? [
          {
            label: t("allowListSettingsLabel"),
            key: CampaignSettingKey.AllowListSettings,
          },
        ]
      : []),
    { label: t("geoSettingsLabel"), key: CampaignSettingKey.GeoSettings },
    { label: t("budgetLabel"), key: CampaignSettingKey.Budget },
    { label: t("rateLimitLabel"), key: CampaignSettingKey.RateLimit },
    { label: t("campaignThresholdSettingLabel"), key: CampaignSettingKey.CampaignThreshold },
    { label: t("staggeredSendLabel"), key: CampaignSettingKey.StaggeredSend },
    { label: t("partnerSettingLabel"), key: CampaignSettingKey.PartnerSetting },
    { label: t("providerSettingLabel"), key: CampaignSettingKey.ProviderSetting },
    { label: t("appInboxSettingLabel"), key: CampaignSettingKey.AppInboxSetting },
  ];

  let campaignContent: React.ReactNode = null;
  switch (campaignSettingTab) {
    case CampaignSettingKey.CampaignAnalytics:
      campaignContent = <CampaignAnalyticsNav currentAppKey={currentAppKey} updateCurrentAppKey={fetchCurrentAppKeys} />;
      break;
    case CampaignSettingKey.CampaignConfigurator:
      campaignContent = <CampaignConfigurator currentAppKey={currentAppKey} />;
      break;
    case CampaignSettingKey.PushNotificationSettings:
      campaignContent = <PushNotificationSetting currentAppKey={currentAppKey} updateCurrentAppKey={fetchCurrentAppKeys} />;
      break;
    case CampaignSettingKey.AllowListSettings:
      campaignContent = <AllowList currentAppKey={currentAppKey} updateCurrentAppKey={fetchCurrentAppKeys} />;
      break;
    case CampaignSettingKey.GeoSettings:
      campaignContent = <GoogleMapKey />;
      break;
    case CampaignSettingKey.Budget:
      campaignContent = <Budget />;
      break;
    case CampaignSettingKey.RateLimit:
      campaignContent = <RateLimit />;
      break;
    case CampaignSettingKey.CampaignThreshold:
      campaignContent = <CampaignThreshold />;
      break;
    case CampaignSettingKey.StaggeredSend:
      campaignContent = <StaggeredSend />;
      break;
      case CampaignSettingKey.BeeFreeEditor:
        campaignContent = <EmailEditorSetting />;
        break;
    case CampaignSettingKey.PartnerSetting:
      campaignContent = <Partner currentAppKey={currentAppKey} updateCurrentAppKey={fetchCurrentAppKeys} />;
      break;
    case CampaignSettingKey.ProviderSetting:
      campaignContent = <ProviderSetting currentAppKey={currentAppKey} updateCurrentAppKey={fetchCurrentAppKeys} />;
      break;
    case CampaignSettingKey.AppInboxSetting:
      campaignContent = <AppInbox currentAppKey={currentAppKey} updateCurrentAppKey={fetchCurrentAppKeys} />;
      break;
    default:
      campaignContent = <div />;
  }

  useEffect(() => {
    switch (appTabFilter) {
      case AppTabKey.Push:
        setSelectedComponent(
          <PushNotification/>
        );
        break;

        case AppTabKey.Email:
          setSelectedComponent(
            <EmailNav
              currentAppKey={currentAppKey}
              updateCurrentAppKey={fetchCurrentAppKeys}

            />
          );
          break;

          case AppTabKey.Sms:
            setSelectedComponent(
              <SMS
              smsConfigUn={currentAppKey[0].smsCfg?.gupshup?.un}
              smsConfigPs={currentAppKey[0].smsCfg?.gupshup?.ps}
              updateCurrentAppKey={fetchCurrentAppKeys}
              />
            );
            break

          case AppTabKey.WebPush:
            setSelectedComponent(
              <WebPushNotification/>
            );
            break

          case AppTabKey.Ads:
            setSelectedComponent(
              <Channel updateCurrentAppKey={fetchCurrentAppKeys} />
            );
            break

            case AppTabKey.Global:
            setSelectedComponent(
              <>
                <InnerNav
                  theme="light"
                  onTabClick={(e) => setCampaignSettingTab(e.key as CampaignSettingKey)}
                  selected={campaignSettingTab}
                  menu={campaignSettingTabs}
                />
                <div className="mt-3" key={campaignSettingTab}>{campaignContent}</div>
              </>
            );
            break
         
    
      // Add cases for other tabs
      default:
        setSelectedComponent(<div></div>); // Default empty component
    }
  }, [ appTabFilter, currentAppKey, campaignSettingTab]);

  // Event handler for tab clicks
  const onTabClick: MenuProps["onClick"] = (e) => {
    setAppTabFilter(e.key as AppTabKey);
  };

  return (
    <Fragment>
      <div className="push-notification-nav-container ">
        <div className="push-notification-nav-heading">
          <InnerNav
            theme="light"
            onTabClick={onTabClick}
            selected={appTabFilter}
            menu={[
              {
                label: t("mobilePushNotificationLabel"),
                key: AppTabKey.Push,
              },
              {
                label: t("emailLabel"),
                key: AppTabKey.Email,
              },
              {
                label: t("smsLabel"),
                key: AppTabKey.Sms,
              },
              {
                label: t("wpnLabel"),
                key: AppTabKey.WebPush,
              },
              {
                label: t("adsLabel"),
                key: AppTabKey.Ads,
              },
              {
                label: t("globalLabel"),
                key: AppTabKey.Global,
              },
             ]}
          />
        </div>
      </div>
      {selectedComponent}
    </Fragment>
  );
};

export default Channels;